import { FirstClassDocument } from '../../types';
import { UNCHUNKED_DOCUMENT_CHUNK_ID } from '../../types/chunkedDocuments';
// eslint-disable-next-line import/no-cycle
import { globalState } from '../models';
import { documentSpineToArray } from '../stateHooks/useChunksForDocument';

export function getSpineForDoc(docId: FirstClassDocument['id']): string[] {
  const docSpine = globalState.getState().transientDocumentsData[docId].spine;
  return docSpine ? documentSpineToArray(docSpine) : [UNCHUNKED_DOCUMENT_CHUNK_ID];
}
